import React, { useRef } from "react";
import { useInView } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa6";
import { useLang } from "../Utility/Languagecontext";
import { COMPANY, whatsappUrl } from "../Data/Company";
import { MaskLine, Reveal } from "../Utility/Motion";

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z" />
  </svg>
);
const MailIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </svg>
);

// "عندك وحدة على الخارطة؟ اعرضها معانا" + أيقونات التواصل
export const ListWithUs = ({ id = "list-your-unit" }) => {
  const { t } = useLang();
  const c = t.listWithUs;
  const ref = useRef(null);
  const inView = useInView(ref, { amount: 0.3 });

  return (
    <section className="listus" id={id}>
      <Reveal className="listus__panel" y={40}>
        <i className="listus__arch" aria-hidden="true" />
        <div className="listus__text" ref={ref}>
          <p className="listus__label">{c.label}</p>
          <h2 className="listus__title">
            {c.title.map((line, i) => (
              <MaskLine key={line} show={inView} delay={i * 0.14}>
                {line}
              </MaskLine>
            ))}
          </h2>
          <p className="listus__body">{c.text}</p>
        </div>
        <div className="listus__actions">
          <a className="btn btn--solid listus__btn" href={whatsappUrl(c.waMessage)} target="_blank" rel="noopener noreferrer">
            <FaWhatsapp aria-hidden="true" />
            <span>{c.whatsapp}</span>
          </a>
          <a className="btn btn--ghost listus__btn" href={`tel:${COMPANY.phone}`}>
            <PhoneIcon />
            <span>{c.call}</span>
          </a>
          <a className="btn btn--ghost listus__btn" href={`mailto:${COMPANY.email}?subject=${encodeURIComponent(c.waMessage)}`}>
            <MailIcon />
            <span>{c.email}</span>
          </a>
        </div>
      </Reveal>
    </section>
  );
};
